export default __webpack_public_path__ + "static/media/ChinasaEdeh.3bf10fef.svg";